package pwgs.ui.scenes.projectmembersscene

import kotlinx.serialization.Serializable
import pwgs.dtos.EUserLevel
import visage.rmi.VisageController

@VisageController(ProjectMembersSceneProps::class, ProjectMembersSceneModel::class)
interface ProjectMembers {
    fun load()
    fun removeMember(userId: String)
}

@Serializable
class ProjectMembersSceneProps(val projectId: Long)

@Serializable
class ProjectMembersSceneModel(
    val members: List<ProjectMembersItemModel>
) {
    var isLoading = true
}

@Serializable
class ProjectMembersItemModel(
    val userId: String,
    val userName: String,
    val email: String,
    val userLevel: EUserLevel
)